import longTermCareService from '@/API/longTermCareService'
import DriverSelector from './DriverSelector.vue'
import DriverLicenseSelector from './DriverLicenseSelector.vue'
export default {
  components: { DriverSelector, DriverLicenseSelector },
  methods: {
    fetchTeamService() {
      longTermCareService.getTeamAvailableServices().then(({ result }) => {
        this.teamAvailableService = result
      })
    },
    setDriverFields(selected) {
      const { driver, driverId, licenseNumber } = selected
      this.$set(this.formData, 'driver', driver)
      this.formData.driverId = driverId
      this.formData.licenseNumber = licenseNumber
    },
    setDriverLicenseFields(licenseNumber) {
      this.$set(this.formData, 'driver', {
        ...this.formData.driver,
        licenseNumber,
      })
      this.formData.licenseNumber = licenseNumber
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/longTermCare/_DriverMixin.js